import { LABOR_AMEND_FLOWSHEET_SAVE_ERROR_TITLE } from "@/encounters/components/EncounterLabor/constants/labor-encounter-amend";
import { toast } from "@/utils/notifications";

/** Shown when submit runs before the questionnaire finished loading or after a load failure. */
export function showLaborFlowsheetFormNotLoadedToast() {
  toast({
    type: "error",
    title: LABOR_AMEND_FLOWSHEET_SAVE_ERROR_TITLE,
    message: "The form could not be loaded. Close the drawer and open it again before saving.",
    autoClose: false,
  });
}
